<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>《命运骑士团》是一款火影忍者的策略卡牌手游，以原汁原味的忍界世界观为基底，融合卡牌收集、策略布阵、角色养成与热血对战等多元玩法，带领玩家重温鸣人、佐助等忍者的成长之路，亲历木叶崛起、忍界大战等经典篇章，书写属于自己的忍者传奇。</p>
    <!-- <pre> -->
    <div class="content">
      <div class="content-item">
        <h4>【高颜值】</h4>
          场景完美复刻木叶村、雾隐村、晓组织据点等经典地标，搭配动态光影与天气系统，每一处细节都充满怀旧感
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【多玩法】</h4>
          玩法模式兼具趣味性与挑战性，主线剧情严格遵循原著时间线，以电影级过场动画重现木叶崩溃、佩恩入侵、忍界大战等高光战役
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【高策略】</h4>
          核心玩法聚焦 “策略卡牌 + 羁绊联动”，构建风雷水火土五大查克拉属性克制体系，玩家需灵活搭配忍者阵容
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【多福利】</h4>
          放置挂机玩法解放双手，离线也能积累资源，轻松养成不肝不累
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
